export default "/images/ea53e1c5ccf1cf21dbb5848ef5b0d171.avif";